import { QueryRequestHelper } from "./query-request-helper";

export const allParams = () => {
  // Move the URL search params extraction inside the function
  const urlSearchParams = new URLSearchParams(window.location.search);
  const UrlParams = Object.fromEntries(urlSearchParams.entries());

  let payload = {
    ...UrlParams,
  };

  let queryRequest = QueryRequestHelper(payload);
  return queryRequest;
};

export const allParamsExceptSearch = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const allParams = Object.fromEntries(urlSearchParams.entries());

  // Filter out unwanted keys
  const filteredParams = Object.fromEntries(
    Object.entries(allParams).filter(
      ([key]) =>
        ![
          "is_all_time",
          "search_text",
          "limit",
          "from_date",
          "to_date",
          "compliance_type_id",
          "compliance_status",
          "owner_due_date_from",
          "owner_due_date_to",
          "date",
        ].includes(key)
    )
  );

  // Create the payload and process it with QueryRequestHelper
  const payload = { ...filteredParams };
  const queryRequest = QueryRequestHelper(payload);

  return queryRequest;
};

export function debounceSearch<F extends (...args: any[]) => void>(
  func: F,
  delay: number
): (...args: Parameters<F>) => void {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<F>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
